import { render, staticRenderFns } from "./PopNewsSlide.vue?vue&type=template&id=18b5c2ae&scoped=true"
import script from "./PopNewsSlide.vue?vue&type=script&lang=js"
export * from "./PopNewsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5c2ae",
  null
  
)

export default component.exports